<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.5 4.4c.3.3.3.8 0 1L10 12l5.6 6.5a.8.8 0 1 1-1.2 1l-6-7a.8.8 0 0 1 0-1l6-7c.3-.3.8-.3 1 0Z"
      fill="currentColor"
    />
  </svg>
</template>
